module.exports = __webpack_public_path__ + "img/circle.08d570cd.svg";